module.exports = new __parcel__URL__("mainframe.5022c6fe.gif").toString();